import { render, staticRenderFns } from "./installation-tank-info.vue?vue&type=template&id=fb6edc38&"
import script from "./installation-tank-info.vue?vue&type=script&lang=js&"
export * from "./installation-tank-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports